import { API_ENDPOINTS } from "@/api/services/attendance/apiEndPoint";
import { baseApi } from "@/utils/baseApi";
export const attendanceEmployeeTrackerListApi = baseApi.injectEndpoints({

  endpoints: (builder) => ({
    getMyTeamReport: builder.query({
      query: ({ startDate, endDate, schema }) =>
        ({url: API_ENDPOINTS.ATTENDANCE_EMPLOYEE_TRACKER.GET_MY_TEAM_REPORT(startDate, endDate, schema)}),
      providesTags: ["EmployeeTracker"],
    }),

    getTeamMemberReport1: builder.query({
      query: ({ startDate, endDate, empId }) =>
        ({url: API_ENDPOINTS.ATTENDANCE_EMPLOYEE_TRACKER.GET_TEAM_MEMBER_REPORT(startDate, endDate, empId)}),
      providesTags: ["EmployeeTracker"],
    }),

    getTeamMemberReport: builder.query({
      query: ({ startDate, endDate, empId }) =>
        ({url: API_ENDPOINTS.ATTENDANCE_EMPLOYEE_TRACKER.GET_TEAM_MEMBER_REPORT(startDate, endDate, empId)}),
      providesTags: ["EmployeeTracker"],
      transformResponse: (response) => {
        return response.data;
      }
    }),

  }),
});

export const { useGetMyTeamReportQuery, useGetTeamMemberReport1Query, useLazyGetTeamMemberReportQuery } = attendanceEmployeeTrackerListApi;
